/* LUMEYE — 把「数量选择器」移动到 Add to cart 同一行（左：数量，右：按钮）
   PayPal 仍然独占下一行。DOM 用 form="" 关联表单，移动节点不影响提交。 */
(function () {
  "use strict";

  function moveQuantityIntoBuyRow() {
    var rows = document.querySelectorAll(".hdt-product-form__top-buttons");
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      if (row.dataset.lumeyeBuyRow === "1") continue;
      var scope = row.closest("form, .hdt-product-info__list") || document;
      var qty = scope.querySelector(".hdt-product-form__quantity") ||
                document.querySelector(".hdt-product-form__quantity");
      if (!qty) continue;
      var wrapper = qty.parentElement;
      row.insertBefore(qty, row.firstElementChild);
      row.classList.add("lumeye-buy-row");
      row.dataset.lumeyeBuyRow = "1";
      if (wrapper && wrapper !== row && !wrapper.children.length) {
        wrapper.style.display = "none";
      }
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", moveQuantityIntoBuyRow);
  } else {
    moveQuantityIntoBuyRow();
  }
  document.addEventListener("shopify:section:load", moveQuantityIntoBuyRow);
})();
